const TOKEN_KEY = 'auth_token'

export function getToken (): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken (): void {
  localStorage.removeItem(TOKEN_KEY)
}

export function isLoggedIn (): boolean {
  return !!getToken()
}

export function logout (): void {
  removeToken()
}
